import { useEffect } from 'react';

import { useUnreadNotificationCount } from './use-notifications';

/**
 * Hook to update the browser tab title with unread notification count
 * Shows count like Gmail: "(3) Public Pulse" or just "Public Pulse" when no unread notifications
 */
export function useNotificationTitle() {
  const { data: unreadCount = 0 } = useUnreadNotificationCount();

  useEffect(() => {
    // Update document title with unread count
    document.title = unreadCount > 0 ? `(${unreadCount}) Public Pulse` : 'Public Pulse';

    // Cleanup: reset title on unmount
    return () => {
      document.title = 'Public Pulse';
    };
  }, [unreadCount]);
}
